<template>
  <footer class="py-3 footer">
    <div class="container-fluid">
      <div class="row align-items-center justify-content-lg-between">
        <div class="mb-4 col-lg-6 mb-lg-0">
          <div
            class="text-sm text-center copyright text-muted"
            :class="this.$store.state.isRTL ? 'text-lg-end' : 'text-lg-start'"
          >
            ©
            {{ new Date().getFullYear() }}, feito com
            <i class="fa fa-heart"></i> por
            <a
              href="https://www.fintail.com.br"
              class="font-weight-bold"
              target="_blank"
              >Fintail</a
            >
            por uma web melhor.
          </div>
        </div>
        <div class="col-lg-6">
          <ul
            class="nav nav-footer justify-content-center justify-content-lg-end"
          >
            <li class="text-sm nav-item font-weight-bold">
              Ver {{ versao }}_{{ env }}{{data}}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "app-footer",
  data() {
    return {
      versao: process.env.VUE_APP_VERSION,
      data: process.env.VUE_APP_VERSION_DATE,
      env: process.env.NODE_ENV,
    }
  },
};
</script>
